export const PRIVACY_TERMS_URL = 'https://www.vet4all.com.br/termos-de-uso/';
export const PRIVACY_POLICY_URL =
  'https://www.vet4all.com.br/politica-de-privacidade/';

/* Playstore app linking URL */
export const PLAYSTORE_DOWNLOAD_URL =
  'https://play.google.com/store/apps/details?id=br.com.vet4all';

/* AppStore URL */
export const APPSTORE_DOWNLOAD_URL =
  'https://apps.apple.com/br/app/vet4all/id1590264785';

/* Playstore web URL */
export const PLAYSTORE_ANDROID_APP_DOWNLOAD_URL =
  'market://details?id=br.com.vet4all';

/**
 * Firebase dynamic link to open Android/Apple store to install
 * if app is installed, will be opened. Otherwise, app store will be leunched
 */
export const FIREBASE_DYNAMIC_LINKING_APP_STORES_DOWNLOAD =
  'https://vet4all.page.link/app-download';
